import { openBlock as h, createElementBlock as c, toDisplayString as S, createCommentVNode as _, createElementVNode as i, resolveComponent as v, createBlock as C } from "vue";
const y = (s) => {
  for (var r = 0, e = 0; e < s.length; e++) {
    var n = s.charCodeAt(e);
    r = (r << 5) - r + n, r = r & r;
  }
  return Math.abs(r);
}, P = (s, r) => Math.floor(s / Math.pow(10, r) % 10), T = (s, r) => !(P(s, r) % 2), o = (s, r, e) => {
  let n = s % r;
  return e && P(s, e) % 2 === 0 ? -n : n;
}, x = (s, r, e) => r[s % e], q = (s) => {
  if (!s)
    return "#FFFFFF";
  s.slice(0, 1) === "#" && (s = s.slice(1));
  var r = parseInt(s.substr(0, 2), 16), e = parseInt(s.substr(2, 2), 16), n = parseInt(s.substr(4, 2), 16), l = (r * 299 + e * 587 + n * 114) / 1e3;
  return l >= 128 ? "#000000" : "#FFFFFF";
}, B = {
  variant: "marble",
  colors: ["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"],
  name: "Clara Barton",
  square: !1,
  hasTitle: !1,
  size: 40
}, M = 4, g = 80;
function b(s, r) {
  const e = y(s), n = r && r.length;
  return Array.from({ length: M }, (t, a) => ({
    color: x(e + a, r, n),
    translateX: o(e * (a + 1), g / 2 - (a + 17), 1),
    translateY: o(e * (a + 1), g / 2 - (a + 17), 2),
    rotate: o(e * (a + 1), 360),
    isSquare: T(e, 2)
  }));
}
const w = (s, r) => {
  const e = s.__vccOpts || s;
  for (const [n, l] of r)
    e[n] = l;
  return e;
}, L = {
  name: "avatar-bauhaus",
  props: ["name", "colors", "size", "hasTitle", "square"],
  data() {
    return { SIZE: g };
  },
  methods: {
    properties(s, r) {
      return b(s, r);
    },
    getSquareTransform() {
      var s, r, e, n, l, t;
      return "translate(" + ((r = (s = this.properties(this.name, this.colors)) == null ? void 0 : s[1]) == null ? void 0 : r.translateX) + " " + ((n = (e = this.properties(this.name, this.colors)) == null ? void 0 : e[1]) == null ? void 0 : n.translateY) + ") rotate(" + ((t = (l = this.properties(this.name, this.colors)) == null ? void 0 : l[1]) == null ? void 0 : t.rotate) + " " + g / 2 + " " + g / 2 + ")";
    },
    getCircleTransform() {
      var s, r, e, n;
      return "translate(" + ((r = (s = this.properties(this.name, this.colors)) == null ? void 0 : s[2]) == null ? void 0 : r.translateX) + " " + ((n = (e = this.properties(this.name, this.colors)) == null ? void 0 : e[2]) == null ? void 0 : n.translateY) + ")";
    },
    getLineTransform() {
      var s, r, e, n, l, t;
      return "translate(" + ((r = (s = this.properties(this.name, this.colors)) == null ? void 0 : s[3]) == null ? void 0 : r.translateX) + " " + ((n = (e = this.properties(this.name, this.colors)) == null ? void 0 : e[3]) == null ? void 0 : n.translateY) + ") rotate(" + ((t = (l = this.properties(this.name, this.colors)) == null ? void 0 : l[3]) == null ? void 0 : t.rotate) + " " + g / 2 + " " + g / 2 + ")";
    }
  }
}, O = ["viewBox", "width", "height"], U = { key: 0 }, N = ["width", "height"], X = ["width", "height", "rx"], Y = { mask: "url(#mask__bauhaus)" }, R = ["width", "height", "fill"], D = ["x", "y", "width", "height", "fill", "transform"], G = ["cx", "cy", "fill", "r", "transform"], H = ["y1", "x2", "y2", "stroke", "transform"];
function V(s, r, e, n, l, t) {
  var a, u, m, E, I, Z, F, k, z, A;
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", U, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__bauhaus",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, X)
    ], 8, N),
    i("g", Y, [
      i("rect", {
        width: l.SIZE,
        height: l.SIZE,
        fill: (u = (a = t.properties(e.name, e.colors)) == null ? void 0 : a[0]) == null ? void 0 : u.color
      }, null, 8, R),
      i("rect", {
        x: (l.SIZE - 60) / 2,
        y: (l.SIZE - 20) / 2,
        width: l.SIZE,
        height: (E = (m = t.properties(e.name, e.colors)) == null ? void 0 : m[1]) != null && E.isSquare ? l.SIZE : l.SIZE / 8,
        fill: (Z = (I = t.properties(e.name, e.colors)) == null ? void 0 : I[1]) == null ? void 0 : Z.color,
        transform: t.getSquareTransform()
      }, null, 8, D),
      i("circle", {
        cx: l.SIZE / 2,
        cy: l.SIZE / 2,
        fill: (k = (F = t.properties(e.name, e.colors)) == null ? void 0 : F[2]) == null ? void 0 : k.color,
        r: l.SIZE / 5,
        transform: t.getCircleTransform()
      }, null, 8, G),
      i("line", {
        x1: 0,
        y1: l.SIZE / 2,
        x2: l.SIZE,
        y2: l.SIZE / 2,
        strokeWidth: 2,
        stroke: (A = (z = t.properties(e.name, e.colors)) == null ? void 0 : z[3]) == null ? void 0 : A.color,
        transform: t.getLineTransform()
      }, null, 8, H)
    ])
  ], 8, O);
}
const W = /* @__PURE__ */ w(L, [["render", V]]), f = 36;
function j(s, r) {
  const e = y(s), n = r && r.length, l = x(e, r, n), t = o(e, 10, 1), a = t < 5 ? t + f / 9 : t, u = o(e, 10, 2), m = u < 5 ? u + f / 9 : u;
  return {
    wrapperColor: l,
    faceColor: q(l),
    backgroundColor: x(e + 13, r, n),
    wrapperTranslateX: a,
    wrapperTranslateY: m,
    wrapperRotate: o(e, 360),
    wrapperScale: 1 + o(e, f / 12) / 10,
    isMouthOpen: T(e, 2),
    isCircle: T(e, 1),
    eyeSpread: o(e, 5),
    mouthSpread: o(e, 3),
    faceRotate: o(e, 10, 3),
    faceTranslateX: a > f / 6 ? a / 2 : o(e, 8, 1),
    faceTranslateY: m > f / 6 ? m / 2 : o(e, 7, 2)
  };
}
const J = {
  name: "avatar-beam",
  props: ["name", "colors", "size", "hasTitle", "square"],
  data() {
    return { SIZE: f };
  },
  methods: {
    data(s, r) {
      return j(s, r);
    },
    getRectTransform() {
      return "translate(" + this.data(this.name, this.colors).wrapperTranslateX + " " + this.data(this.name, this.colors).wrapperTranslateY + ") rotate(" + this.data(this.name, this.colors).wrapperRotate + " " + f / 2 + " " + f / 2 + ") scale(" + this.data(this.name, this.colors).wrapperScale + ")";
    },
    getGroupTransform() {
      return "translate(" + this.data(this.name, this.colors).faceTranslateX + " " + this.data(this.name, this.colors).faceTranslateY + ") rotate(" + this.data(this.name, this.colors).faceRotate + " " + f / 2 + " " + f / 2 + ")";
    },
    getOpenMouthData() {
      return "M15 " + (19 + this.data(this.name, this.colors).mouthSpread) + "c2 1 4 1 6 0";
    },
    getClosedMouthData() {
      return "M13," + (19 + this.data(this.name, this.colors).mouthSpread) + " a1,0.75 0 0,0 10,0";
    }
  }
}, K = ["viewBox", "width", "height"], Q = { key: 0 }, p = ["width", "height"], $ = ["width", "height", "rx"], ee = { mask: "url(#mask__beam)" }, te = ["width", "height", "fill"], le = ["width", "height", "transform", "fill", "rx"], ie = ["transform"], re = ["d", "stroke"], se = ["d", "fill"], ne = ["x", "width", "fill"], ae = ["x", "width", "fill"];
function he(s, r, e, n, l, t) {
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", Q, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__beam",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, $)
    ], 8, p),
    i("g", ee, [
      i("rect", {
        width: l.SIZE,
        height: l.SIZE,
        fill: t.data(e.name, e.colors).backgroundColor
      }, null, 8, te),
      i("rect", {
        x: "0",
        y: "0",
        width: l.SIZE,
        height: l.SIZE,
        transform: t.getRectTransform(),
        fill: t.data(e.name, e.colors).wrapperColor,
        rx: t.data(e.name, e.colors).isCircle ? l.SIZE : l.SIZE / 6
      }, null, 8, le),
      i("g", {
        transform: t.getGroupTransform()
      }, [
        t.data(e.name, e.colors).isMouthOpen ? (h(), c("path", {
          key: 0,
          fill: "none",
          strokeLinecap: "round",
          d: t.getOpenMouthData(),
          stroke: t.data(e.name, e.colors).faceColor
        }, null, 8, re)) : (h(), c("path", {
          key: 1,
          d: t.getClosedMouthData(),
          fill: t.data(e.name, e.colors).faceColor
        }, null, 8, se)),
        i("rect", {
          stroke: "none",
          x: 14 - t.data(e.name, e.colors).eyeSpread,
          y: 14,
          width: 1.5,
          height: 2,
          rx: 1,
          fill: t.data(e.name, e.colors).faceColor
        }, null, 8, ne),
        i("rect", {
          stroke: "none",
          x: 20 + t.data(e.name, e.colors).eyeSpread,
          y: 14,
          width: 1.5,
          height: 2,
          rx: 1,
          fill: t.data(e.name, e.colors).faceColor
        }, null, 8, ae)
      ], 8, ie)
    ])
  ], 8, K);
}
const oe = /* @__PURE__ */ w(J, [["render", he]]), ce = 3, d = 80;
function _e(s, r) {
  const e = y(s), n = r && r.length;
  return Array.from({ length: ce }, (t, a) => ({
    color: x(e + a, r, n),
    translateX: o(e * (a + 1), d / 10, 1),
    translateY: o(e * (a + 1), d / 10, 2),
    scale: 1.2 + o(e * (a + 1), d / 20) / 10,
    rotate: o(e * (a + 1), 360, 1)
  }));
}
const ue = {
  name: "avatar-marble",
  props: ["name", "colors", "size", "hasTitle", "square"],
  data() {
    return { SIZE: d };
  },
  methods: {
    properties(s, r) {
      return _e(s, r);
    },
    getPathOneTransform() {
      return "translate(" + this.properties(this.name, this.colors)[1].translateX + " " + this.properties(this.name, this.colors)[1].translateY + ") rotate(" + this.properties(this.name, this.colors)[1].rotate + " " + d / 2 + " " + d / 2 + ") scale(" + this.properties(this.name, this.colors)[2].scale + ")";
    },
    getPathTwoTransform() {
      return "translate(" + this.properties(this.name, this.colors)[2].translateX + " " + this.properties(this.name, this.colors)[2].translateY + ") rotate(" + this.properties(this.name, this.colors)[2].rotate + " " + d / 2 + " " + d / 2 + ") scale(" + this.properties(this.name, this.colors)[2].scale + ")";
    }
  }
}, fe = ["viewBox", "width", "height"], me = { key: 0 }, de = ["width", "height"], ge = ["width", "height", "rx"], xe = { mask: "url(#mask__marble)" }, we = ["width", "height", "fill"], ve = ["fill", "transform"], Ce = ["fill", "transform"], Se = /* @__PURE__ */ i("defs", null, [
  /* @__PURE__ */ i("filter", {
    id: "prefix__filter0_f",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, [
    /* @__PURE__ */ i("feFlood", {
      result: "BackgroundImageFix",
      floodOpacity: 0
    }),
    /* @__PURE__ */ i("feBlend", {
      in: "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }),
    /* @__PURE__ */ i("feGaussianBlur", {
      result: "effect1_foregroundBlur",
      stdDeviation: 7
    })
  ])
], -1);
function ye(s, r, e, n, l, t) {
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", me, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__marble",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, ge)
    ], 8, de),
    i("g", xe, [
      i("rect", {
        width: l.SIZE,
        height: l.SIZE,
        fill: t.properties(e.name, e.colors)[0].color
      }, null, 8, we),
      i("path", {
        filter: "url(#prefix__filter0_f)",
        d: "M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z",
        fill: t.properties(e.name, e.colors)[1].color,
        transform: t.getPathOneTransform()
      }, null, 8, ve),
      i("path", {
        filter: "url(#prefix__filter0_f)",
        d: "M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z",
        style: {
          mixBlendMode: "overlay"
        },
        fill: t.properties(e.name, e.colors)[2].color,
        transform: t.getPathTwoTransform()
      }, null, 8, Ce)
    ]),
    Se
  ], 8, fe);
}
const Ee = /* @__PURE__ */ w(ue, [["render", ye]]), Ie = 64, Ze = 80;
function Te(s, r) {
  const e = y(s), n = r && r.length;
  return Array.from({ length: Ie }, (t, a) => x(e % a, r, n));
}
const Fe = {
  name: "avatar-pixel",
  props: ["size", "hasTitle", "name", "square", "colors"],
  data() {
    return { SIZE: Ze };
  },
  methods: {
    pixelColors(s, r) {
      return Te(s, r);
    }
  }
}, ke = ["viewBox", "width", "height"], ze = { key: 0 }, Ae = ["width", "height"], Pe = ["width", "height", "rx"], qe = { mask: "url(#mask__pixel)" }, Be = ["fill"], Me = ["fill"], be = ["fill"], Le = ["fill"], Oe = ["fill"], Ue = ["fill"], Ne = ["fill"], Xe = ["fill"], Ye = ["fill"], Re = ["fill"], De = ["fill"], Ge = ["fill"], He = ["fill"], Ve = ["fill"], We = ["fill"], je = ["fill"], Je = ["fill"], Ke = ["fill"], Qe = ["fill"], pe = ["fill"], $e = ["fill"], et = ["fill"], tt = ["fill"], lt = ["fill"], it = ["fill"], rt = ["fill"], st = ["fill"], nt = ["fill"], at = ["fill"], ht = ["fill"], ot = ["fill"], ct = ["fill"], _t = ["fill"], ut = ["fill"], ft = ["fill"], mt = ["fill"], dt = ["fill"], gt = ["fill"], xt = ["fill"], wt = ["fill"], vt = ["fill"], Ct = ["fill"], St = ["fill"], yt = ["fill"], Et = ["fill"], It = ["fill"], Zt = ["fill"], Tt = ["fill"], Ft = ["fill"], kt = ["fill"], zt = ["fill"], At = ["fill"], Pt = ["fill"], qt = ["fill"], Bt = ["fill"], Mt = ["fill"], bt = ["fill"], Lt = ["fill"], Ot = ["fill"], Ut = ["fill"], Nt = ["fill"], Xt = ["fill"], Yt = ["fill"], Rt = ["fill"];
function Dt(s, r, e, n, l, t) {
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", ze, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__pixel",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, Pe)
    ], 8, Ae),
    i("g", qe, [
      i("rect", {
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[0]
      }, null, 8, Be),
      i("rect", {
        x: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[1]
      }, null, 8, Me),
      i("rect", {
        x: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[2]
      }, null, 8, be),
      i("rect", {
        x: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[3]
      }, null, 8, Le),
      i("rect", {
        x: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[4]
      }, null, 8, Oe),
      i("rect", {
        x: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[5]
      }, null, 8, Ue),
      i("rect", {
        x: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[6]
      }, null, 8, Ne),
      i("rect", {
        x: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[7]
      }, null, 8, Xe),
      i("rect", {
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[8]
      }, null, 8, Ye),
      i("rect", {
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[9]
      }, null, 8, Re),
      i("rect", {
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[10]
      }, null, 8, De),
      i("rect", {
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[11]
      }, null, 8, Ge),
      i("rect", {
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[12]
      }, null, 8, He),
      i("rect", {
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[13]
      }, null, 8, Ve),
      i("rect", {
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[14]
      }, null, 8, We),
      i("rect", {
        x: 20,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[15]
      }, null, 8, je),
      i("rect", {
        x: 20,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[16]
      }, null, 8, Je),
      i("rect", {
        x: 20,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[17]
      }, null, 8, Ke),
      i("rect", {
        x: 20,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[18]
      }, null, 8, Qe),
      i("rect", {
        x: 20,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[19]
      }, null, 8, pe),
      i("rect", {
        x: 20,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[20]
      }, null, 8, $e),
      i("rect", {
        x: 20,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[21]
      }, null, 8, et),
      i("rect", {
        x: 40,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[22]
      }, null, 8, tt),
      i("rect", {
        x: 40,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[23]
      }, null, 8, lt),
      i("rect", {
        x: 40,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[24]
      }, null, 8, it),
      i("rect", {
        x: 40,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[25]
      }, null, 8, rt),
      i("rect", {
        x: 40,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[26]
      }, null, 8, st),
      i("rect", {
        x: 40,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[27]
      }, null, 8, nt),
      i("rect", {
        x: 40,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[28]
      }, null, 8, at),
      i("rect", {
        x: 60,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[29]
      }, null, 8, ht),
      i("rect", {
        x: 60,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[30]
      }, null, 8, ot),
      i("rect", {
        x: 60,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[31]
      }, null, 8, ct),
      i("rect", {
        x: 60,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[32]
      }, null, 8, _t),
      i("rect", {
        x: 60,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[33]
      }, null, 8, ut),
      i("rect", {
        x: 60,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[34]
      }, null, 8, ft),
      i("rect", {
        x: 60,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[35]
      }, null, 8, mt),
      i("rect", {
        x: 10,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[36]
      }, null, 8, dt),
      i("rect", {
        x: 10,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[37]
      }, null, 8, gt),
      i("rect", {
        x: 10,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[38]
      }, null, 8, xt),
      i("rect", {
        x: 10,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[39]
      }, null, 8, wt),
      i("rect", {
        x: 10,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[40]
      }, null, 8, vt),
      i("rect", {
        x: 10,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[41]
      }, null, 8, Ct),
      i("rect", {
        x: 10,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[42]
      }, null, 8, St),
      i("rect", {
        x: 30,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[43]
      }, null, 8, yt),
      i("rect", {
        x: 30,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[44]
      }, null, 8, Et),
      i("rect", {
        x: 30,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[45]
      }, null, 8, It),
      i("rect", {
        x: 30,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[46]
      }, null, 8, Zt),
      i("rect", {
        x: 30,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[47]
      }, null, 8, Tt),
      i("rect", {
        x: 30,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[48]
      }, null, 8, Ft),
      i("rect", {
        x: 30,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[49]
      }, null, 8, kt),
      i("rect", {
        x: 50,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[50]
      }, null, 8, zt),
      i("rect", {
        x: 50,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[51]
      }, null, 8, At),
      i("rect", {
        x: 50,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[52]
      }, null, 8, Pt),
      i("rect", {
        x: 50,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[53]
      }, null, 8, qt),
      i("rect", {
        x: 50,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[54]
      }, null, 8, Bt),
      i("rect", {
        x: 50,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[55]
      }, null, 8, Mt),
      i("rect", {
        x: 50,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[56]
      }, null, 8, bt),
      i("rect", {
        x: 70,
        y: 10,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[57]
      }, null, 8, Lt),
      i("rect", {
        x: 70,
        y: 20,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[58]
      }, null, 8, Ot),
      i("rect", {
        x: 70,
        y: 30,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[59]
      }, null, 8, Ut),
      i("rect", {
        x: 70,
        y: 40,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[60]
      }, null, 8, Nt),
      i("rect", {
        x: 70,
        y: 50,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[61]
      }, null, 8, Xt),
      i("rect", {
        x: 70,
        y: 60,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[62]
      }, null, 8, Yt),
      i("rect", {
        x: 70,
        y: 70,
        width: 10,
        height: 10,
        fill: t.pixelColors(e.name, e.colors)[63]
      }, null, 8, Rt)
    ])
  ], 8, ke);
}
const Gt = /* @__PURE__ */ w(Fe, [["render", Dt]]), Ht = 90, Vt = 5;
function Wt(s, r) {
  const e = y(r), n = s && s.length, l = Array.from({ length: Vt }, (a, u) => x(e + u, s, n)), t = [];
  return t[0] = l[0], t[1] = l[1], t[2] = l[1], t[3] = l[2], t[4] = l[2], t[5] = l[3], t[6] = l[3], t[7] = l[0], t[8] = l[4], t;
}
const jt = {
  name: "avatar-ring",
  props: ["size", "hasTitle", "name", "square", "colors"],
  data() {
    return { SIZE: Ht };
  },
  methods: {
    ringColors(s, r) {
      return Wt(r, s);
    }
  }
}, Jt = ["viewBox", "width", "height"], Kt = { key: 0 }, Qt = ["width", "height"], pt = ["width", "height", "rx"], $t = { mask: "url(#mask__ring)" }, el = ["fill"], tl = ["fill"], ll = ["fill"], il = ["fill"], rl = ["fill"], sl = ["fill"], nl = ["fill"], al = ["fill"], hl = ["fill"];
function ol(s, r, e, n, l, t) {
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", Kt, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__ring",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, pt)
    ], 8, Qt),
    i("g", $t, [
      i("path", {
        d: "M0 0h90v45H0z",
        fill: t.ringColors(e.name, e.colors)[0]
      }, null, 8, el),
      i("path", {
        d: "M0 45h90v45H0z",
        fill: t.ringColors(e.name, e.colors)[1]
      }, null, 8, tl),
      i("path", {
        d: "M83 45a38 38 0 00-76 0h76z",
        fill: t.ringColors(e.name, e.colors)[2]
      }, null, 8, ll),
      i("path", {
        d: "M83 45a38 38 0 01-76 0h76z",
        fill: t.ringColors(e.name, e.colors)[3]
      }, null, 8, il),
      i("path", {
        d: "M77 45a32 32 0 10-64 0h64z",
        fill: t.ringColors(e.name, e.colors)[4]
      }, null, 8, rl),
      i("path", {
        d: "M77 45a32 32 0 11-64 0h64z",
        fill: t.ringColors(e.name, e.colors)[5]
      }, null, 8, sl),
      i("path", {
        d: "M71 45a26 26 0 00-52 0h52z",
        fill: t.ringColors(e.name, e.colors)[6]
      }, null, 8, nl),
      i("path", {
        d: "M71 45a26 26 0 01-52 0h52z",
        fill: t.ringColors(e.name, e.colors)[7]
      }, null, 8, al),
      i("circle", {
        cx: 45,
        cy: 45,
        r: 23,
        fill: t.ringColors(e.name, e.colors)[8]
      }, null, 8, hl)
    ])
  ], 8, Jt);
}
const cl = /* @__PURE__ */ w(jt, [["render", ol]]), _l = 4, ul = 80;
function fl(s, r) {
  const e = y(s), n = r && r.length;
  return Array.from({ length: _l }, (t, a) => x(e + a, r, n));
}
const ml = {
  name: "avatar-sunset",
  props: ["name", "size", "hasTitle", "square", "colors"],
  data() {
    return { SIZE: ul };
  },
  computed: {
    formattedName() {
      return this.name.replace(/\s/g, "");
    }
  },
  methods: {
    sunsetColors(s, r) {
      return fl(s, r);
    },
    getPaintFill0() {
      return "url(#gradient_paint0_linear_" + this.formattedName + ")";
    },
    getPaintFill1() {
      return "url(#gradient_paint1_linear_" + this.formattedName + ")";
    },
    getPaintId0() {
      return "gradient_paint0_linear_" + this.formattedName;
    },
    getPaintId1() {
      return "gradient_paint1_linear_" + this.formattedName;
    }
  }
}, dl = ["viewBox", "width", "height"], gl = { key: 0 }, xl = ["width", "height"], wl = ["width", "height", "rx"], vl = { mask: "url(#mask__sunset)" }, Cl = ["fill"], Sl = ["fill"], yl = ["id", "x1", "x2", "y2"], El = ["stop-color"], Il = ["stop-color"], Zl = ["id", "x1", "y1", "x2", "y2"], Tl = ["stop-color"], Fl = ["stop-color"];
function kl(s, r, e, n, l, t) {
  return h(), c("svg", {
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 " + l.SIZE + " " + l.SIZE,
    width: e.size,
    height: e.size
  }, [
    e.hasTitle ? (h(), c("title", gl, S(e.name), 1)) : _("", !0),
    i("mask", {
      id: "mask__sunset",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: l.SIZE,
      height: l.SIZE
    }, [
      i("rect", {
        fill: "#FFFFFF",
        width: l.SIZE,
        height: l.SIZE,
        rx: e.square ? void 0 : l.SIZE * 2
      }, null, 8, wl)
    ], 8, xl),
    i("g", vl, [
      i("path", {
        d: "M0 0h80v40H0z",
        fill: t.getPaintFill0()
      }, null, 8, Cl),
      i("path", {
        d: "M0 40h80v40H0z",
        fill: t.getPaintFill1()
      }, null, 8, Sl)
    ]),
    i("defs", null, [
      i("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: t.getPaintId0(),
        x1: l.SIZE / 2,
        y1: 0,
        x2: l.SIZE / 2,
        y2: l.SIZE / 2
      }, [
        i("stop", {
          "stop-color": t.sunsetColors(e.name, e.colors)[0]
        }, null, 8, El),
        i("stop", {
          offset: 1,
          "stop-color": t.sunsetColors(e.name, e.colors)[1]
        }, null, 8, Il)
      ], 8, yl),
      i("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: t.getPaintId1(),
        x1: l.SIZE / 2,
        y1: l.SIZE / 2,
        x2: l.SIZE / 2,
        y2: l.SIZE
      }, [
        i("stop", {
          "stop-color": t.sunsetColors(e.name, e.colors)[2]
        }, null, 8, Tl),
        i("stop", {
          offset: 1,
          "stop-color": t.sunsetColors(e.name, e.colors)[3]
        }, null, 8, Fl)
      ], 8, Zl)
    ])
  ], 8, dl);
}
const zl = /* @__PURE__ */ w(ml, [["render", kl]]), Al = {
  name: "avatar",
  components: {
    AvatarBauhaus: W,
    AvatarBeam: oe,
    AvatarMarble: Ee,
    AvatarPixel: Gt,
    AvatarRing: cl,
    AvatarSunset: zl
  },
  props: ["variant", "colors", "name", "square", "hasTitle", "size"],
  data() {
    return { defaultAvatarProps: B };
  }
};
function Pl(s, r, e, n, l, t) {
  const a = v("avatar-bauhaus"), u = v("avatar-beam"), m = v("avatar-marble"), E = v("avatar-pixel"), I = v("avatar-ring"), Z = v("avatar-sunset");
  return h(), c("div", null, [
    e.variant === "bauhaus" ? (h(), C(a, {
      key: 0,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0),
    e.variant === "beam" ? (h(), C(u, {
      key: 1,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0),
    e.variant === "marble" ? (h(), C(m, {
      key: 2,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0),
    e.variant === "pixel" ? (h(), C(E, {
      key: 3,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0),
    e.variant === "ring" ? (h(), C(I, {
      key: 4,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0),
    e.variant === "sunset" ? (h(), C(Z, {
      key: 5,
      colors: e.colors || l.defaultAvatarProps.colors,
      name: e.name || l.defaultAvatarProps.name,
      square: e.square || l.defaultAvatarProps.square,
      hasTitle: e.hasTitle || l.defaultAvatarProps.hasTitle,
      size: e.size || l.defaultAvatarProps.size
    }, null, 8, ["colors", "name", "square", "hasTitle", "size"])) : _("", !0)
  ]);
}
const Bl = /* @__PURE__ */ w(Al, [["render", Pl]]);
export {
  Bl as Avatar
};
